import { WorkflowReportSettings } from "../types/types"
import { getSelectedServer } from "./apiServerStore"
import { getAccessToken } from "./authHelpers"
import { genericRequest, analysisRoute, analysisRouteV2 } from "./service"

export const getAnalysis = async (sectionScanId: number) => {
  return genericRequest({ url: `${analysisRoute}/${sectionScanId}`, method: "GET" })
}

export const getScaledRawData = async (sectionScanId: number) => {
  return genericRequest({ url: `${analysisRoute}/${sectionScanId}`, method: "GET" })
}

/**
 * Gets the default processed THz heatmap image for a workflow.
 * 
 * @param sectionId of workflow to fetch heatmap for
 * 
 * @returns processed section
 */
export const getDefaultProcessedTHzHeatmapImage = async (sectionId: number) => {
  return genericRequest({ url: `${analysisRoute}/default/${sectionId}`, method: "GET" })
}

export const processWorkflow = async (workflowId: number, withCalibration: boolean) => {
  return genericRequest({ url: `${analysisRoute}/process/${workflowId}/${withCalibration}`, method: "GET" })
}

export const downloadReport = async (workflowId: number, reportSettings: WorkflowReportSettings) => {
  try {
    const token = await getAccessToken()
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    }

    const baseUrl = getSelectedServer()
    const fullUrl = new URL(`${baseUrl}${analysisRouteV2}/${workflowId}/report`)

    const response = await fetch(fullUrl.toString(), {
      method: "POST",
      headers: headers,
      body: JSON.stringify(reportSettings),
      redirect: "error"
    })

    if (response.ok) {
      return response
    }

    if (response.status === 401) {
      return Error("401", { cause: `${401}` })
    }

    const errorData = await response.json().catch(() => {
      throw Error(`Request failed`, { cause: `${response.status} ${response.statusText}` });
    })

    return Error(errorData.detail, { cause: `${response.status}` })

  } catch (error) {
    return Error(`An error occured: ${error}`)
  }
}